export enum Domain {
  CHECKOUT = 'checkout',
  EXPERIENCE = 'experience',
  MEMBERS_AREA = 'members-area',
  OLD_SAMPLE_TRIP = 'old-sample-trip',
  OLD_TRIP = 'old-trip',
  SAMPLE_TRIP = 'sample-trip',
  STAFF_AREA = 'staff-area',
  TRIP = 'trip',
}
